import React from 'react';
import t from '~t';

import { Section, SectionTitle, SectionActions, Button, Icon } from '~ui';

export default function CollectionsGroupView({
  title,
  system,
  active,
  hidden,
  isDragging,
  isDropping,
  onClick,
  onContextMenu,
  onCreateNewCollectionClick,
}) {
  if (system) return null;

  return (
    <Section
      className='cursor-pointer'
      active={active}
      isDragging={isDragging}
      isDropping={isDropping}
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      <SectionTitle>{title}</SectionTitle>

      <SectionActions>
        {/*<Button
            title={t.s('createNewCollection')}
            onClick={onCreateNewCollectionClick}>
            <Icon name='add' />
        </Button>*/}

        {hidden ? (
          <Button variant='outline' size='sm'>
            {t.s('show')}
          </Button>
        ) : (
          <Button
            variant='ghost'
            size='icon'
            title={t.s('more')}
            onClick={onContextMenu}
          >
            <Icon name='more_horizontal' />
          </Button>
        )}
      </SectionActions>
    </Section>
  );
}
